import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "preBidSchedule", "preBidFields", "preBidTimezoneCol", "preBidExtras", "preBidLocationLink", "preBidLocationFields",
    "diffTzCheckbox", "preBidTzSelect", "bidOpeningTzSelect",
    "bidSchedule", "bidOpeningFields", "bidOpeningTzCol",
    "rebidRow",
    "submitBtn"
  ]

  connect() {
    this.element.querySelector("form")?.addEventListener("submit", () => this._disableSubmit())
  }

  _disableSubmit() {
    const btn = this.submitBtnTarget
    btn.disabled = true
    btn.innerHTML = `<svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-white inline-block" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path></svg>Saving...`
    btn.classList.add("opacity-75", "cursor-not-allowed")
  }

  preBidScheduleChanged() {
    const val = this.preBidScheduleTarget.value
    const show = val !== "no"
    const showLocation = val === "onsite" || val === "onsite_virtual"

    this._toggle(this.preBidFieldsTarget, show)
    this._toggle(this.preBidTimezoneColTarget, show)
    this._toggle(this.preBidExtrasTarget, show)

    const fieldsExpanded = this.hasPreBidLocationFieldsTarget && !this.preBidLocationFieldsTarget.classList.contains("hidden")
    if (this.hasPreBidLocationLinkTarget) {
      this._toggle(this.preBidLocationLinkTarget, showLocation && !fieldsExpanded)
    }
    if (!showLocation) {
      this._toggle(this.preBidLocationFieldsTarget, false)
    }
  }

  togglePreBidLocation(event) {
    event.preventDefault()
    if (this.hasPreBidLocationLinkTarget) this.preBidLocationLinkTarget.classList.add("hidden")
    this._toggle(this.preBidLocationFieldsTarget, true)
  }

  clearPreBidLocation(event) {
    event.preventDefault()
    this.preBidLocationFieldsTarget.querySelectorAll("input").forEach(i => i.value = "")
    this._toggle(this.preBidLocationFieldsTarget, false)
    if (this.hasPreBidLocationLinkTarget) this.preBidLocationLinkTarget.classList.remove("hidden")
  }

  bidMeetingScheduleChanged() {
    const show = this.bidScheduleTarget.value !== "tbd"
    this._toggle(this.bidOpeningFieldsTarget, show)
    this._toggle(this.bidOpeningTzColTarget, show)
    if (this.hasRebidRowTarget) this._toggle(this.rebidRowTarget, show)
  }

  bidTimezoneChanged(event) {
    if (!this.hasDiffTzCheckboxTarget || this.diffTzCheckboxTarget.checked) return

    const other = event.target === this.preBidTzSelectTarget
      ? this.bidOpeningTzSelectTarget
      : this.preBidTzSelectTarget
    other.value = event.target.value
  }

  diffPreBidTimezoneChanged() {
    if (!this.diffTzCheckboxTarget.checked && this.hasBidOpeningTzSelectTarget && this.hasPreBidTzSelectTarget) {
      this.preBidTzSelectTarget.value = this.bidOpeningTzSelectTarget.value
    }
  }

  _toggle(el, show) {
    if (show) {
      el.classList.remove("hidden")
    } else {
      el.classList.add("hidden")
    }
  }
}
